import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Typography,
  theme,
  Checkbox,
  Steps,
  message,
  Alert,
  Select,
  Row,
  Col,
  Space,
  Divider,
  notification,
} from "antd";
import { MinusCircleOutlined, PlusOutlined, EyeTwoTone, EyeInvisibleOutlined, ConsoleSqlOutlined } from "@ant-design/icons";
import TenantApi from "../../common/Apis/TenantApi";
import RateApi from "../../common/Apis/RatesApi";
import UserApi from "../../common/Apis/UserApi";
import { createDefaultTenant } from "../../../models/Tenant/TenantDTO";
import { createDefaultTenantRate } from "../../../models/Rate/TenantRateDTO";
import { createDefaultTenantAdminUser } from "../../../models/Tenant/TenantAdminDTO";
import SubtenantApi from "../../common/Apis/SubtenantApi";
import { createDefaultSubTenant } from "../../../models/SubTenant/SubTenantDTO";

const { Title } = Typography;
const { Step } = Steps;
const { Option } = Select;

const CreateTenantModel = ({ visible, onCancel, form, onTenantCreated }) => {
  const { token } = theme.useToken();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [currentStep, setCurrentStep] = useState(0);
  const [steps, setSteps] = useState([{ title: "Tenant Info" }, { title: "Currency" }, { title: "Subscription" }, { title: "Admin Info" }]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [tenantCreationSuccess, setTenantCreationSuccess] = useState(false);
  const [tenantCurrencyCreationSuccess, setTenantCurrencyCreationSuccess] = useState(false);
  const [tenantRateAddingSuccess, setTenantRateAddingSuccess] = useState(false);
  const [newlyCreatedTenant, setNewlyCreatedTenant] = useState(null);
  const [savedShops, setSavedShops] = useState([]);

  useEffect(() => {
    validateRequiredFields();
  }, [currentStep]);

  useEffect(() => {
    if (visible) {
      form.resetFields();   // clear all fields
      setCurrentStep(0);    // back to step 0
      setApiError(null);    // clear old errors
      setTenantCreationSuccess(false);
      setTenantCurrencyCreationSuccess(false);
      setTenantRateAddingSuccess(false);
      setNewlyCreatedTenant(null);
      setSavedShops([]);
    }
  }, [visible]);

  const handleFieldsChange = () => {
    validateRequiredFields();
  };

  const validateRequiredFields = () => {
    let requiredFields = [];
    const stepTitle = steps[currentStep]?.title;

    if (stepTitle === "Tenant Info") {
      requiredFields = ["tenantCode", "tenantName", "contactPerson", "contactAddress"];
    } else if (stepTitle === "Currency") {
      requiredFields = ["currency"];
    } else if (stepTitle === "Subscription") {
      // requiredFields = ["paymentTerm", "rate"];
      requiredFields = ["paymentTerm"];
    } else if (stepTitle === "Admin Info") {
      console.log("ok");
      requiredFields = ["firstName", "lastName", "email", "password", "confirmPassword"];
    } else if (stepTitle === "Sub-Tenants") {
      // optional: disable next if no sub-tenants added
      // const subTenants = form.getFieldValue("subTenants") || [];
      // setIsButtonDisabled(savedShops.length === 0);
      // return;
    }

    const hasErrors = form.getFieldsError(requiredFields).some(({ errors }) => errors.length > 0);
    const touchedRequiredFields = requiredFields.every((field) => form.isFieldTouched(field));

    let emailOrPhoneValid = true;
    if (stepTitle === "Tenant Info") {
      const email = form.getFieldValue("contactEmail");
      const phone = form.getFieldValue("contactPhone");
      if (!email && !phone) emailOrPhoneValid = false;
    }

    setIsButtonDisabled(!touchedRequiredFields || hasErrors || !emailOrPhoneValid);
  };

  const handleNext = () => {
    const stepTitle = steps[currentStep]?.title;

    if (stepTitle === "Tenant Info") {
      form.validateFields([
        "tenantCode",
        "tenantName",
        "multitenancy",
        "contactPerson",
        "contactAddress",
        "contactEmail",
        "contactPhone",
      ]).then((values) => {
        if (!values.contactEmail && !values.contactPhone) {
          message.error("Either Contact Email or Contact Phone is required.");
          return;
        }

        const payload = createDefaultTenant({
          tenantCode: values.tenantCode,
          tenantName: values.tenantName,
          multitenancy: values.multitenancy,
          contactPerson: values.contactPerson,
          contactEmail: values.contactEmail || null,
          contactPhone: values.contactPhone || null,
          contactAddress: values.contactAddress,
          createdBy: decodedToken?.username || "",
          modifiedBy: decodedToken?.username || "",
        });

        setLoading(true);
        TenantApi.CreateTenant(payload)
          .then((res) => {
            setTenantCreationSuccess(true);
            setApiError(null);
            setNewlyCreatedTenant(res?.payload);
            setCurrentStep(currentStep + 1);
            setLoading(false);
          })
          .catch((err) => {
            setApiError(err?.apiError?.message || err?.message || "Tenant creation failed.");
            setTenantCreationSuccess(false);
            setLoading(false);
          });
      });
    }

    else if (stepTitle === "Currency") {
      form.validateFields(["currency"]).then((values) => {

        const payload = createDefaultTenant({
          ...newlyCreatedTenant,
          currency: values.currency,
        });

        TenantApi.Edittenants(newlyCreatedTenant?.id, payload)
          .then(() => {
            setApiError(null);
            setTenantCurrencyCreationSuccess(true);
            setCurrentStep(currentStep + 1);
            // notification.open({
            //   message: (
            //     <span style={{ fontWeight: "bold" }}>
            //       Tenant / Customer deactivated successfully!
            //     </span>
            //   ),
            //   closeIcon: false,
            //   duration: 3,
            //   style: {
            //     backgroundColor: "#b3ffb3",
            //     color: "green",
            //   },
            // });
          })
          .catch((err) => {
            setTenantCurrencyCreationSuccess(false);
            console.error("Error adding currency:", err);
            setApiError(err?.apiError?.message || err?.message || "currency added failed");
            // notification.open({
            //   message: (
            //     <span style={{ fontWeight: "bold" }}>
            //       Failed to deactivate tenant
            //     </span>
            //   ),
            //   description: error?.response?.data?.message || "An unexpected error occurred.",
            //   closeIcon: false,
            //   duration: 4,
            //   style: {
            //     backgroundColor: "#ffcccc",
            //     color: "red",
            //   },
            // });
          });

      })
    }

    // else if (stepTitle === "Sub-Tenants") {
    //   const subTenants = form.getFieldValue("subTenants") || [];
    //   if (!subTenants.length) {
    //     message.error("Add at least one sub-tenant.");
    //     return;
    //   }

    //   // setLoading(true);
    //   setCurrentStep(currentStep + 1);
    // }

    else if (stepTitle === "Subscription") {
      // form.validateFields(["paymentTerm", "rate"])
      form.validateFields(["paymentTerm"])
        .then((values) => {
          const payload = createDefaultTenantRate({
            tenantDTO: { id: newlyCreatedTenant?.id },
            billingCycle: values.paymentTerm,
            agreedRate: 0,
            tenantRate: 0,
          });

          setLoading(true);
          RateApi.AddRateForTenant(payload)
            .then(() => {
              setTenantRateAddingSuccess(true);
              setApiError(null);
              setCurrentStep(currentStep + 1);
              setLoading(false);
            })
            .catch((err) => {
              setTenantRateAddingSuccess(false);
              setApiError(err?.message || "Failed to add subscription plan.");
              setLoading(false);
            });
        });
    }

    else if (stepTitle === "Admin Info") {
      form.validateFields(["firstName", "lastName", "email", "password", "confirmPassword"])
        .then((values) => {
          const payload = createDefaultTenantAdminUser({
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            password: values.password,
            matchingPassword: values.confirmPassword,
            tenantDTO: { id: newlyCreatedTenant?.id },
          });

          setLoading(true);
          UserApi.CreateTenantAdmin(payload)
            .then(() => {
              notification.open({
                message: <span style={{ fontWeight: "bold" }}>New tenant / cusotmer added successfully!</span>,
                closeIcon: false,
                duration: 3,
                style: {
                  backgroundColor: "#b3ffb3",
                  color: "green",
                },
              });
              onCancel();
              onTenantCreated();
              setCurrentStep(0);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setApiError(err?.apiError.message || "Failed to add tenant admin.");
              setLoading(false);
            });
        });
    }
  };

  const renderStepContent = () => {
    const stepTitle = steps[currentStep]?.title;

    switch (stepTitle) {
      case "Tenant Info":
        return (
          <>
            {apiError && <Alert message={apiError} type="error" showIcon className="mb-3" />}
            <Form
              form={form}
              layout="vertical"
              name="tenant-info-form"
              onFieldsChange={handleFieldsChange}
            >
              {/* Tenant Info Form Items */}
              <Form.Item
                name="tenantCode"
                label={<span>Tenant Code <span style={{ color: "red" }}>*</span></span>}
                rules={[
                  { required: true, message: "Tenant Code is required" },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();
                      if (/\s/.test(value)) return Promise.reject("No spaces allowed");
                      if (!/^[a-zA-Z0-9_-]*$/.test(value)) return Promise.reject("Only letters, numbers, hyphen, underscore");
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input placeholder="Enter tenant code" />
              </Form.Item>

              <Form.Item name="tenantName" label={<span>Tenant Name <span style={{ color: "red" }}>*</span></span>} rules={[{ required: true }]}>
                <Input placeholder="Enter tenant name" />
              </Form.Item>

              <Form.Item name="contactPerson" label={<span>Contact Person <span style={{ color: "red" }}>*</span></span>} rules={[{ required: true }]}>
                <Input placeholder="Enter contact person" />
              </Form.Item>

              <Form.Item
                name="contactEmail"
                label="Contact Email"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const phone = getFieldValue("contactPhone");
                      if (!value && !phone) return Promise.reject("Either Email or Phone is required");
                      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return Promise.reject("Invalid email format");
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input placeholder="Enter contact email" />
              </Form.Item>

              <Form.Item
                name="contactPhone"
                label="Contact Phone"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const email = getFieldValue("contactEmail");
                      if (!value && !email) return Promise.reject("Either Phone or Email is required");
                      if (value && !/^[0-9+\-\s()]+$/.test(value)) return Promise.reject("Invalid phone format");
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input placeholder="Enter contact phone" />
              </Form.Item>

              <Form.Item name="contactAddress" label={<span>Contact Address <span style={{ color: "red" }}>*</span></span>} rules={[{ required: true }]}>
                <Input.TextArea placeholder="Enter contact address" />
              </Form.Item>

              <div className="d-flex align-items-center">
                <label className="me-2">Is this Tenant / Customer has multiple stores?</label>
                <Form.Item name="multitenancy" valuePropName="checked" noStyle initialValue={false}>
                  <Checkbox />
                </Form.Item>
              </div>
            </Form>
          </>
        );

      case "Currency":
        return (
          <>
            {tenantCreationSuccess && <Alert message="Tenant Created Successfully!" type="success" showIcon className="mb-3" />}
            {apiError && <Alert message={apiError} type="error" showIcon className="mb-3" />}
            <Alert message="Please select this customer's default currency. This will be used for all currency-related operations for this customer." type="info" showIcon className="mb-3" />
            <Form
              form={form}
              name="nest-messages"
              layout="horizontal"
              wrapperCol={{
                span: 24,
              }}
              className="FormClass IndividualProduct-Model"
              onFieldsChange={handleFieldsChange}
            >
              <>
                <Form.Item
                  name="currency"
                  className="text-lable disabled"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Currency ",
                    },
                  ]}
                >
                  <Select
                    className="control-Select"
                    placeholder="Select Currency"
                  >
                    <option value="€"> Euro</option>
                    <option value="$"> Dollar</option>
                  </Select>
                </Form.Item>


                {/* <div className="d-flex justify-content-center pt-2">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="btn btn-primary btn-save mx-2"
                    style={{ width: "37%" }}
                  >
                    Save
                  </Button>

                </div> */}
              </>
            </Form>
          </>
        );

      case "Sub-Tenants":

        return (
          <Form form={form} name="subtenant-form" onFieldsChange={handleFieldsChange}>
            <Form.List name="subTenants">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => {
                    const isSaved = savedShops.includes(index);

                    return (
                      <div
                        key={key}
                        style={{
                          marginBottom: 16,
                          padding: 12,
                          border: "1px solid #f0f0f0",
                          borderRadius: 6,
                        }}
                      >
                        <Space
                          align="baseline"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 8,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Shop {index + 1}</span>
                          {!isSaved && <MinusCircleOutlined onClick={() => remove(name)} />}
                        </Space>

                        <Row gutter={16}>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, "subTenantName"]}
                              rules={[{ required: true, message: "Missing Shop Name" }]}
                            >
                              <Input placeholder="Shop Name" disabled={isSaved} />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, "subTenantCode"]}
                              rules={[{ required: true, message: "Missing Shop Code" }]}
                            >
                              <Input placeholder="Shop Code" disabled={isSaved} />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row gutter={16}>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, "contactPerson"]}
                              rules={[{ required: true, message: "Missing Contact Person" }]}
                            >
                              <Input placeholder="Contact Person" disabled={isSaved} />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, "contactEmail"]}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const phone = getFieldValue(["subTenants", name, "contactPhone"]);
                                    if (!value && !phone)
                                      return Promise.reject("Either Email or Phone is required");
                                    if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
                                      return Promise.reject("Invalid email format");
                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                            >
                              <Input placeholder="Contact Email" disabled={isSaved} />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row gutter={16}>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, "contactPhone"]}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const email = getFieldValue(["subTenants", name, "contactEmail"]);
                                    if (!value && !email)
                                      return Promise.reject("Either Phone or Email is required");
                                    if (value && !/^[0-9+\-\s()]+$/.test(value))
                                      return Promise.reject("Invalid phone format");
                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                            >
                              <Input placeholder="Contact Phone" disabled={isSaved} />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              name={[name, "contactAddress"]}
                              rules={[{ required: true, message: "Missing contact address" }]}
                            >
                              <Input.TextArea placeholder="Contact Address" disabled={isSaved} />
                            </Form.Item>
                          </Col>
                        </Row>

                        <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
                          {!isSaved ? (
                            <Button
                              type="primary"
                              onClick={() => {
                                form
                                  .validateFields([
                                    ["subTenants", name, "subTenantName"],
                                    ["subTenants", name, "subTenantCode"],
                                    ["subTenants", name, "contactPerson"],
                                    ["subTenants", name, "contactEmail"],
                                    ["subTenants", name, "contactPhone"],
                                    ["subTenants", name, "contactAddress"],
                                  ])
                                  .then(() => {
                                    const values = form.getFieldValue("subTenants")[name];

                                    const payload = createDefaultSubTenant({
                                      subTenantCode: values.subTenantCode,
                                      subTenantName: values.subTenantName,
                                      tenantDTO: { id: newlyCreatedTenant?.id },
                                    });

                                    setLoading(true);
                                    SubtenantApi.Createsubtenants(payload)
                                      .then((res) => {
                                        message.success("Shop saved successfully!");
                                        if (res?.payload?.id) {
                                          setSavedShops((prev) => [...prev, index]); // freeze this shop
                                        }
                                        setIsButtonDisabled(false);
                                      })
                                      .catch((err) => {
                                        message.error(
                                          err?.apiError?.message ||
                                          "Failed to create store / shop. Please try again."
                                        );
                                      })
                                      .finally(() => setLoading(false));
                                  })
                                  .catch(() => message.error("Please fix form errors before saving."));
                              }}
                            >
                              Save Shop
                            </Button>
                          ) : (
                            <span style={{ color: "green", fontWeight: "bold" }}>✅ Saved</span>
                          )}
                        </div>
                        <Divider />
                      </div>
                    );
                  })}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add Shop
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Form>
        );



      case "Subscription":
        return (
          <>
            {tenantCurrencyCreationSuccess && <Alert message="Tenant Currency Created Successfully!" type="success" showIcon className="mb-3" />}
            {apiError && <Alert message={apiError} type="error" showIcon className="mb-3" />}
            <Form form={form} layout="vertical" name="subscription-form" onFieldsChange={handleFieldsChange}>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="paymentTerm" label="Payment Term" rules={[{ required: true }]}>
                    <Select placeholder="Select Payment Term">
                      <Option value="MONTHLY">Monthly</Option>
                      <Option value="ANNUALLY">Annual</Option>
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col span={12}>
                  <Form.Item name="rate" label="Rate" rules={[
                    { required: true },
                    { validator: (_, value) => value < 0 ? Promise.reject("Rate cannot be negative") : Promise.resolve() },
                  ]}>
                    <Input type="number" placeholder="Enter rate" />
                  </Form.Item>
                </Col> */}
              </Row>
            </Form>
          </>
        );

      case "Admin Info":
        return (
          <>
            {tenantRateAddingSuccess && <Alert message="Tenant Rate Added Successfully!" type="success" showIcon className="mb-3" />}
            {apiError && <Alert message={apiError} type="error" showIcon className="mb-3" />}
            <Form
              form={form}
              onFieldsChange={handleFieldsChange}
              name="admin-form">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="firstName"
                    label={
                      <span>
                        First Name <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[{ required: true, message: "Please enter first name" }]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input placeholder="First Name" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="lastName"
                    label={
                      <span>
                        Last Name <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[{ required: true, message: "Please enter last name" }]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input placeholder="Last Name" />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    name="email"
                    label={
                      <span>
                        Email Address <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[{ required: true, message: "Please enter email address" }]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input placeholder="Email address" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="password"
                    label={
                      <span>
                        Password <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[{ required: true, message: "Please enter password" }]}
                    validateTrigger="onChange"
                    labelCol={{ span: 24 }}     // makes label take full width on top
                    wrapperCol={{ span: 24 }}   // makes input and error message full width below label
                  >
                    <Input.Password
                      placeholder="Password"
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="confirmPassword"
                    label={
                      <span>
                        Re-enter Password <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    dependencies={["password"]}
                    rules={[
                      { required: true, message: "Please re-enter password" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error("Passwords do not match"));
                        },
                      }),
                    ]}
                    validateTrigger="onChange"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input.Password
                      placeholder="Re-enter Password"
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Modal
      footer={null}
      width={650}
      open={visible}
      maskClosable={false}
      onCancel={onCancel}
      closable={currentStep === 0}
    >
      <Title level={4} className="text-center mb-3">Add New Tenant / Customer</Title>
      <Steps current={currentStep} size="small" className="mb-4 px-4">
        {steps.map((s, idx) => <Step key={idx} title={s.title} />)}
      </Steps>

      {renderStepContent()}

      <div className="d-flex justify-content-between mt-4">
        <Button
          type="primary"
          style={{ width: "100%" }}
          disabled={isButtonDisabled || loading}
          onClick={handleNext}
        >
          {currentStep === steps.length - 1 ? "Complete & Close" : "Save & Next"}
        </Button>
      </div>
    </Modal>
  );
};

export default CreateTenantModel;
